import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateTherapiesPagination } from '../../store/actions/therapy/therapy_action';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import SearchComponent from '../ui_components/search';
import TherapiesTable from './therapies_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const TherapyList = ({ therapies }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = therapies;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateTherapiesPagination({...therapies, page: 0, filters: { ...filters, search }}))
    }

    const handleAddTherapyClick = () => {
        history.push(REACT_ROUTES.THERAPY);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Terapije
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddTherapyClick}
                    >
                        Kreirajte novu terapiju
                    </Button>
                </Grid>
            </Grid>
            <TherapiesTable />
        </Container>
    )
}

TherapyList.propTypes = {
    therapies: PropTypes.object
}

const mapStateToProps = (state) => ({
    therapies: state.therapies
});

export default connect(mapStateToProps)(TherapyList);
